import * as React from "react";
import type { SVGProps } from "react";
const SvgHamam = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21 20v-9c0-.28-.12-.55-.32-.74l-.42-.38c.5-.79.74-1.67.74-2.68 0-2.56-1.89-4.63-3.72-5.16-.18-.05-.37-.05-.55 0-1.83.53-3.72 2.6-3.72 5.16 0 1.01.24 1.89.74 2.68l-.42.38c-.21.19-.32.46-.32.74v2h-2v-2c0-.28-.12-.55-.32-.74l-.42-.38c.5-.79.74-1.67.74-2.68-.01-2.56-1.9-4.63-3.73-5.16-.18-.05-.37-.05-.55 0C4.89 2.57 3 4.64 3 7.2c0 1.01.24 1.89.74 2.68l-.42.38c-.21.19-.32.46-.32.74v9c-.55 0-1 .45-1 1s.45 1 1 1h18c.55 0 1-.45 1-1s-.45-1-1-1m-6-8.56.77-.7c.2-.18.31-.43.32-.7a1 1 0 0 0-.27-.72c-.56-.6-.82-1.27-.82-2.12 0-1.46.99-2.7 2-3.14 1.01.44 2 1.68 2 3.14 0 .84-.26 1.52-.82 2.12-.18.2-.28.46-.27.72 0 .27.13.52.32.7l.77.7V20h-1v-3c0-.55-.45-1-1-1v-2c0-.55-.45-1-1-1h-1zM9 15h6v1H9zm-1 3h8v2H8zm-3-6.56.77-.7c.2-.18.31-.43.32-.7a1 1 0 0 0-.27-.72C5.26 8.72 5 8.05 5 7.2c0-1.46.99-2.7 2-3.14 1.01.44 2 1.68 2 3.14 0 .84-.26 1.52-.82 2.12-.18.2-.28.46-.27.72 0 .27.13.52.32.7l.77.7V13H8c-.55 0-1 .45-1 1v2c-.55 0-1 .45-1 1v3H5z"
    />
  </svg>
);
export default SvgHamam;
